// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .advice-container{\n  background-color: rgba(164, 193, 239, 0.309);\n}\n\n\n", ""]);
// Exports
module.exports = exports;
